const clearSpaces = (string = '') => string
  .replace(/\s+/g, '');
export default clearSpaces;